import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../../translation/translation_container';
import Tooltip from '../../../../tooltip/tooltip';
import { Checkbox } from '../../../../form/floating_label/checkbox';

function FilterCheckbox(props) {
    return (
        <div className="catalog-filter-section__filter">
            <TranslationContainer
                targetProperties={{
                    label: { translationKey: props.labelTranslationKey }
                }}
            >
                <Checkbox
                    name={props.name}
                    checked={props.checked}
                    onChange={props.onChange}
                    disabled={props.disabled}
                    label="will-be-replaced"
                />
            </TranslationContainer>
            <Tooltip
                content={props.tooltipContent}
                additionalClassNames={['catalog-filter-section__filter-help']}
                onShowToolTip={props.onToolTipHover}
                attention={props.disabled}
            />
        </div>
    );
}

FilterCheckbox.propTypes = {
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    tooltipContent: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export { FilterCheckbox };
